import { peekSpareReference } from '../../../services/mutations';
import { spareCaseRefPeekSnapshot } from '../peekRefSnapshot';

let peekDebounceTimer: ReturnType<typeof setTimeout> | undefined;

/** Debounced ref peek when vessel / date / categories change on New Case. */
export function scheduleSpareCaseReferencePeek(
  setMultipleFieldValues: (updates: Record<string, unknown>) => void,
  getFormData: () => Record<string, unknown>,
): void {
  if (peekDebounceTimer) clearTimeout(peekDebounceTimer);
  peekDebounceTimer = setTimeout(() => {
    peekDebounceTimer = undefined;
    void fillSpareCaseReferenceFromTemplate(setMultipleFieldValues, getFormData);
  }, 200);
}

/** Immediate peek (e.g. initial mount). */
export async function fillSpareCaseReferenceFromTemplate(
  setMultipleFieldValues: (updates: Record<string, unknown>) => void,
  getFormData: () => Record<string, unknown>,
): Promise<void> {
  const d = getFormData();
  const caseDate = d.caseDate;
  if (caseDate == null || caseDate === '') return;

  const vesselRaw = d.vesselId;
  const vesselId =
    vesselRaw === '' || vesselRaw === undefined || vesselRaw === null
      ? null
      : Number(vesselRaw);
  if (vesselId != null && !Number.isFinite(vesselId)) return;

  const rawCats = d.categoryIds;
  const categoryIds = Array.isArray(rawCats)
    ? rawCats.map((x) => Number(x)).filter((n) => Number.isFinite(n))
    : [];

  try {
    const { ref } = await peekSpareReference({
      entityType: 'SPARE_CASE',
      vesselId,
      categoryIds,
      dateForYear: typeof caseDate === 'string' ? caseDate : String(caseDate),
    });
    if (ref != null && ref.trim().length > 0) {
      const trimmed = ref.trim();
      const currentRef = String(getFormData().ref ?? '');
      if (spareCaseRefPeekSnapshot.shouldApplyPeekToForm(currentRef)) {
        spareCaseRefPeekSnapshot.setFromPeek(trimmed);
        setMultipleFieldValues({ ref: trimmed });
      }
    }
  } catch {
    /* optional preview — ignore network errors */
  }
}
